import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 70vh;
  padding: 0 1.375rem;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: 10px;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 2px;
`;

export const CountrySubMessage = styled.p`
  width: 100%;
  color: #474747;
  font-size: 14px;
  font-family: "Lato";
  margin: 0;
  padding: 0;
  font-size: Italic;
`;

export const BorderImage = styled.div`
  padding: 8px;
  border: ${(props) => props.border ?? "solid 0px #fff"};
  border-radius: 5px;
`;

const DASHBOARD_CARD_HEIGHT = "5rem";

// Up to 4.5 cards visible (the half card hints that the list scrolls), never
// more than the room left in the popup (--dashboard-list-space, set by
// AddEditAdmin) and never less than 1.5 cards.
export const DashboardList = styled.div`
  min-width: 0;
  max-height: clamp(
    calc(${DASHBOARD_CARD_HEIGHT} * 1.5),
    var(--dashboard-list-space, calc(${DASHBOARD_CARD_HEIGHT} * 4.5)),
    calc(${DASHBOARD_CARD_HEIGHT} * 4.5)
  );
  overflow-x: hidden;
  overflow-y: auto;
  background: #f1f9fd;
  border: 1px solid #e0eef5;
  border-radius: 4px;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`;

export const DashboardCard = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  box-sizing: border-box;
  height: ${DASHBOARD_CARD_HEIGHT};
  margin: 0;
  padding: 12px 16px;
  border-bottom: 1px solid #dcebf2;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const DashboardCheckbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin: 2px 0 0;
  border: 1px solid #b5b5b5;
  border-radius: 3px;
  background: #fff no-repeat center / 80%;
  cursor: inherit;

  &:checked {
    border-color: #5ac8c8;
    background-color: #5ac8c8;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M3.5 8.5l3 3 6-7' fill='none' stroke='white' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  }

  &:focus-visible {
    outline: 2px solid #1bace4;
    outline-offset: 2px;
  }
`;

export const DashboardContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const DashboardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const DashboardTitle = styled.span`
  ${fontStyles}
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.4;
  color: #474747;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DashboardStatus = styled.span`
  flex-shrink: 0;
  min-width: 78px;
  padding: 2px 12px;
  border-radius: 12px;
  font-family: "Lato";
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  text-transform: capitalize;
  color: ${(props) => (props.published ? "#32a728" : "#666")};
  background-color: ${(props) => (props.published ? "#d9f2d6" : "#eee")};
`;

export const DashboardMeta = styled.div`
  ${fontStyles}
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
  color: #737373;
  text-overflow: ellipsis;
  white-space: nowrap;

  strong {
    font-weight: bold;
  }
`;

export const DashboardMetaSeparator = styled.span`
  margin: 0 8px;
`;

export const DashboardDescription = styled.div`
  ${fontStyles}
  overflow: hidden;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #474747;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DashboardEmpty = styled.div`
  ${fontStyles}
  padding: 12px;
  color: #888;
`;
